export default {
  providers: [],
  currentProviders: [],
  providerResponse: false,
  showUnlockedLevels: false,
  showUnlockedBadges: false
}
